export default __webpack_public_path__ + "static/media/phone_bg_v2.d5fceae3.png";